<!-- src/components/YoutubeMusicPlayer.vue -->
<template>
	<div class="youtube-music-player">
		<div class="player-container">
			<div id="dummy-player"></div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		playlistId: {
			type: String,
			required: true,
		},
	},
	emits: ['state-change'],
	data() {
		return {
			player: null,
			isPlayerReady: false,
			hasStarted: false,
		};
	},
	mounted() {
		this.initPlayer();
	},
	beforeUnmount() {
		if (this.player) {
			this.player.destroy();
		}
	},
	methods: {
		initPlayer() {
			const onPlayerReady = () => {
				this.isPlayerReady = true;
			};

			const onPlayerStateChange = (event) => {
				this.$emit('state-change', event.data === window.YT.PlayerState.PLAYING);
			};

			const onYouTubeIframeAPIReady = () => {
				if (this.player) return; // Prevent multiple player instances
				this.player = new window.YT.Player('dummy-player', {
					height: '360',
					width: '640',
					events: {
						onReady: onPlayerReady,
						onStateChange: onPlayerStateChange,
					},
				});
			};

			if (window.YT && window.YT.Player) {
				setTimeout(() => onYouTubeIframeAPIReady(), 0);
			} else {
				window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
			}
		},
		playPlaylist() {
			if (this.player && this.isPlayerReady) {
				this.player.loadPlaylist({
					listType: 'playlist',
					list: this.playlistId,
					index: 0,
					startSeconds: 0,
				});
				this.hasStarted = true;
			}
		},
		toggle() {
			if (!this.player || !this.isPlayerReady) return;
			if (!this.hasStarted) {
				this.playPlaylist();
				return;
			}
			const state = this.player.getPlayerState();
			if (state === window.YT.PlayerState.PLAYING) {
				this.player.pauseVideo();
			} else {
				this.player.playVideo();
			}
		},
	},
};
</script>

<style scoped>
.youtube-music-player .player-container {
	width: 0;
	height: 0;
	overflow: hidden;
}
</style>
